import { FC, ReactNode } from "react";
import TastaturButton from "./TastaturButton";

type TastaturSpecialCharButtonProps = {
  onPress: () => void;
  children?: ReactNode | ReactNode[];
};

const TastaturSpecialCharButton: FC<TastaturSpecialCharButtonProps> = (props) => {
  return (
    <TastaturButton
      onPress={props.onPress}
      innerClassName={"h-full text-gray-700 bg-gray-400"}
      className="col-span-2 h-full"
    >
      {props.children}
    </TastaturButton>
  );
};
export default TastaturSpecialCharButton;
